export const isEnumValue = <T extends Record<string, string>>(enumObj: T, value: string): value is T[keyof T] => {
  return Object.values(enumObj).includes(value);
};

export const isNumericEnumValue = <T extends Record<string, number | string>>(enumObj: T, value: string): boolean => {
  const numericValue = Number(value);
  if (!isNaN(numericValue)) {
    return Object.values(enumObj).some((v) => typeof v === 'number' && v === numericValue);
  }
  return false;
};
